module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/core-js/library/modules/_add-to-unscopables.js
// module id = 436
// module chunks = 168707334958949